import { WorkExperienceRole, WorkExperienceBullet, WorkExperienceCompany } from '@applicator/shared'

// Helper function to initialize role editing
export function initializeRoleEditing(
  role: WorkExperienceRole,
  setEditingRoleId: (id: string | null) => void,
  setEditingRolePosition: (value: string) => void
) {
  setEditingRoleId(role.id)
  setEditingRolePosition(role.position)
}

// Helper function to get role location value
export function getRoleLocationValue(role: WorkExperienceRole): string {
  return role.location || ''
}

// Helper function to initialize role location editing
export function initializeRoleLocationEditing(
  role: WorkExperienceRole,
  setEditingRoleLocationId: (id: string | null) => void,
  setEditingRoleLocation: (value: string) => void
) {
  setEditingRoleLocationId(role.id)
  setEditingRoleLocation(getRoleLocationValue(role))
}

// Helper function to finalize role location editing
export function finalizeRoleLocationEditing(
  companyId: string,
  roleId: string,
  editingRoleLocation: string,
  handleUpdateRole: (companyId: string, roleId: string, field: 'position' | 'location' | 'employmentType' | 'startDate' | 'endDate', value: string) => void,
  setEditingRoleLocationId: (id: string | null) => void
) {
  handleUpdateRole(companyId, roleId, 'location', editingRoleLocation)
  setEditingRoleLocationId(null)
}

// Helper function to find bullet in role
export function findBulletInRole(role: WorkExperienceRole, bulletId: string): WorkExperienceBullet | undefined {
  return (role.bulletPoints || []).find((b) => b.id === bulletId)
}

// Helper function to find bullet in company
export function findBulletInCompany(company: WorkExperienceCompany, bulletId: string): WorkExperienceBullet | undefined {
  for (const role of company.roles || []) {
    const bullet = findBulletInRole(role, bulletId)
    if (bullet) return bullet
  }
  return undefined
}

// Helper function to find bullet by ID across all companies
export function findBulletById(
  bulletId: string | null,
  companies: WorkExperienceCompany[]
): WorkExperienceBullet | undefined {
  if (!bulletId) return undefined
  for (const company of companies) {
    const bullet = findBulletInCompany(company, bulletId)
    if (bullet) return bullet
  }
  return undefined
}
